(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-stud-section-after-product"]) return;
  try {
    
  (function () {
    function initAPB(root) {
      if (!root || root.dataset.apbInit === '1') return;
      root.dataset.apbInit = '1';

      /* ---- 2. Reviews 3D coverflow ---- */
      (function () {
        var track = root.querySelector('[data-apb-rcf]');
        if (!track) return;
        var cards = track.querySelectorAll('.reviews-cf__card');
        if (!cards.length) return;
        var TOTAL = cards.length, active = Math.min(2, TOTAL - 1), GAP = 270, AUTO = 3500, timer = null;
        var S = [
          { tx:-2, tz:-280, ry:46,  sc:0.63, op:0.22 },
          { tx:-1, tz:-140, ry:28,  sc:0.80, op:0.58 },
          { tx:0,  tz:0,    ry:0,   sc:1.00, op:1.00 },
          { tx:1,  tz:-140, ry:-28, sc:0.80, op:0.58 },
          { tx:2,  tz:-280, ry:-46, sc:0.63, op:0.22 }
        ];
        function render(cur) {
          cards.forEach(function (card, i) {
            var rel = i - cur;
            if (rel > 2) rel -= TOTAL; else if (rel < -2) rel += TOTAL;
            if (card._rel !== undefined && Math.abs(rel - card._rel) > 2) { card.style.transition = 'none'; void card.offsetWidth; }
            else { card.style.transition = ''; }
            card._rel = rel;
            var s = S[rel + 2];
            if (!s) { card.style.opacity = 0; card.style.pointerEvents = 'none'; return; }
            card.style.transform = 'translateX(' + (s.tx * GAP) + 'px) translateZ(' + s.tz + 'px) rotateY(' + s.ry + 'deg) scale(' + s.sc + ')';
            card.style.opacity = s.op;
            card.style.zIndex = 100 - Math.abs(rel) * 2;
            card.style.pointerEvents = 'auto';
            card.classList.toggle('is-active', rel === 0);
          });
        }
        function goTo(i) { active = (i % TOTAL + TOTAL) % TOTAL; render(active); }
        function nextSlide() { goTo(active + 1); }
        function startAuto() { stopAuto(); timer = setInterval(nextSlide, AUTO); }
        function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
        var prevBtn = root.querySelector('.reviews-cf__arrow--prev');
        var nextBtn = root.querySelector('.reviews-cf__arrow--next');
        if (prevBtn) prevBtn.addEventListener('click', function () { goTo(active - 1); startAuto(); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goTo(active + 1); startAuto(); });
        cards.forEach(function (c, i) { c.addEventListener('click', function () { goTo(i); startAuto(); }); });
        var box = track.closest('.reviews-cf__carousel') || track;
        box.addEventListener('mouseenter', stopAuto);
        box.addEventListener('mouseleave', startAuto);
        render(active); startAuto();
      })();
    }

    function boot() {
      document.querySelectorAll('.lp-reviews-cf').forEach(initAPB);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    /* Re-init when section is re-rendered in the theme editor */
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.lp-reviews-cf'); if (el) initAPB(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommendations-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
